module.exports = __webpack_public_path__ + "static/img/dentaltalk_lg_portrait.226d09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/dentaltalk_lg_portrait.png
// module id = IxV/
// module chunks = 1